import { useEffect, useState } from 'react';

import { DOMAINS } from '@/domains';
import { useAppSelector } from '@/redux/hooks';
import { useGetHospitalQuery } from '@/patient-app-common/api/hospitalApi';

export default function useHospitalFlags() {
  const { hostname } = window.location;
  let subdomain = hostname.split('.')[0];

  if (DOMAINS.LOCAL.includes(hostname)) {
    subdomain = 'app-gcp-web';
  }

  const { route } = useAppSelector(({ app }) => app);
  const { data: hospital } = useGetHospitalQuery(subdomain, {
    skip: route === null,
  });

  const [hasAppDownload, setHasAppDownload] = useState(true);
  const [hasLangSelector, setHasLangSelector] = useState(false);
  const [hasOntarioTrustedAccount, setHasOntarioTrustedAccount] =
    useState(false);
  const [hasRecaptcha, setHasRecaptcha] = useState(false);
  const [hasSignup, setHasSignup] = useState(false);
  const [isFrench, setIsFrench] = useState(false);
  const [requirePasswordLength13, setRequirePasswordLength13] = useState(false);

  const setFlags = (features) => {
    features.forEach((feature) => {
      switch (feature) {
        case 'sf_hospital_web_french':
          setIsFrench(true);
          break;
        case 'sf_hospital_web_language_selection':
          setHasLangSelector(true);
          break;

        case 'sf_hospital_web_no_mobile_client':
          setHasAppDownload(false);
          break;

        case 'sf_hospital_web_ontario_trusted_account':
          setHasOntarioTrustedAccount(true);
          break;

        case 'sf_hospital_web_recaptcha':
          setHasRecaptcha(true);
          break;

        case 'sf_hospital_web_signup':
          setHasSignup(true);
          break;

        case 'sf_hospital_web_mobile_patient_password_length_13':
          setRequirePasswordLength13(true);
          break;

        default:
          break;
      }
    });
  };

  useEffect(() => {
    if (!hospital) return;
    setFlags(hospital.features);
  }, [hospital]);

  return {
    hospital,
    hasAppDownload,
    hasLangSelector,
    hasOntarioTrustedAccount,
    hasRecaptcha,
    hasSignup,
    isFrench,
    requirePasswordLength13,
  };
}
